exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* The section wrapper is a flex column, so Main has to flex too or the embedded\n   iframe collapses to its min-height. */\n.xYKpVDHOz8vTH-LELj2O2 {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Plain CSS rather than Box spacing props: the theme defines no space scale, so\n   styled-system treats small numbers as indexes into its default scale (mt={8}\n   is 512px, not 8px). */\n.kc5Hw9H31AxjCwLH0Ypic {\n  margin: 8px 0 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"page": "xYKpVDHOz8vTH-LELj2O2",
	"description": "kc5Hw9H31AxjCwLH0Ypic"
};